import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_PORTAL_URL } from "@/lib/config";
import { axiosApiInstance } from "@/lib/axios";
import { IAttractionsDetails } from "./attractionsModal";
import toast from "react-hot-toast";

const SuccessToast = (msg: string) => toast.success(msg);
const ErrorToast = (msg: string) => toast.error(msg);

export const getAllAttractions = createAsyncThunk("Attraction/FindAllAttraction", async () => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/FindAllAttraction`, { Title: "" });
    return response.data?.Data;
  } catch (error: any) {
    console.error("Error Fetching Attractions:", error);
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const getAllActiveAttractions = createAsyncThunk("Attraction/FindAllActiveAttraction", async () => {
  try {
    const response = await axiosApiInstance.get(`${API_PORTAL_URL}/Attraction/FindAllActiveAttraction`);
    return response.data?.Data;
  } catch (error: any) {
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const getAttractionsByURL = createAsyncThunk("Attraction/AttractionFindByURL", async (AttractionURL: string) => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/AttractionFindByURL`, { AttractionURL });
    const result = response.data?.Data as any;
    return {
      ID: result?.ID, Title: result?.Title, AttractionURL: result?.AttractionURL,
      AttractionCategory: result?.AttractionCategory, TagLine: result?.TagLine,
      Distance: result?.Distance, TravelTime: result?.TravelTime, BestTime: result?.BestTime,
      Duration: result?.Duration, Description: result?.Description, Dos: result?.Dos, Donts: result?.Donts,
      MainImage: result?.MainImage, BannerImage: result?.BannerImage,
      MetaTitle: result?.MetaTitle, MetaDescription: result?.MetaDescription, MetaKeywords: result?.MetaKeywords,
      IsMustVisit: result?.IsMustVisit, IsActive: result?.IsActive ? 1 : 2,
      BestTimes: result?.BestTimes ?? [], HowToReach: result?.HowToReach ?? [],
      ThingsToDo: result?.ThingsToDo ?? [], WhyVisit: result?.WhyVisit ?? [],
      Nearby: result?.Nearby ?? [], Images: result?.Images ?? [],
    } as IAttractionsDetails;
  } catch (error: any) {
    console.error("Error fetching Attractions:", error);
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const getAttractionsByID = createAsyncThunk("Attraction/FindByIDAttraction", async (ID: number) => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/FindByIDAttraction`, { ID });
    const result = response.data?.Data;
    return {
      ID: result?.ID, Title: result?.Title, AttractionURL: result?.AttractionURL,
      AttractionCategory: result?.AttractionCategory, TagLine: result?.TagLine,
      Distance: result?.Distance, TravelTime: result?.TravelTime, BestTime: result?.BestTime,
      Duration: result?.Duration, Description: result?.Description, Dos: result?.Dos, Donts: result?.Donts,
      MainImage: result?.MainImage, BannerImage: result?.BannerImage,
      MetaTitle: result?.MetaTitle, MetaDescription: result?.MetaDescription, MetaKeywords: result?.MetaKeywords,
      IsActive: result?.IsActive ? 1 : 2,
      BestTimes: result?.BestTimes ?? [], HowToReach: result?.HowToReach ?? [],
      ThingsToDo: result?.ThingsToDo ?? [], WhyVisit: result?.WhyVisit ?? [],
      Nearby: result?.Nearby ?? [], Images: result?.Images ?? [],
    } as IAttractionsDetails;
  } catch (error: any) {
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const createAttractions = createAsyncThunk("Attraction/InsertAttraction", async (AttractionsData: any) => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/InsertAttraction`, AttractionsData);
    SuccessToast(response.data?.Details || "Success");
    return response.data;
  } catch (error: any) {
    ErrorToast(error?.response?.data?.Details || "Something went wrong");
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const updateAttractions = createAsyncThunk("Attraction/UpdateAttraction", async (AttractionsData: any) => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/UpdateAttraction`, AttractionsData);
    SuccessToast(response.data?.Details || "Success");
    return response.data;
  } catch (error: any) {
    ErrorToast(error?.response?.data?.Details || "Something went wrong");
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const deleteAttractions = createAsyncThunk("Attraction/DeleteAttraction", async (ID: number) => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/DeleteAttraction`, { ID });
    SuccessToast(response.data?.Details || "Success");
    return response.data;
  } catch (error: any) {
    ErrorToast(error?.response?.data?.Details || "Something went wrong");
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const ActiveInactiveAttractions = createAsyncThunk("Attraction/ActiveInActiveAttraction", async (formData: any) => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/ActiveInActiveAttraction`, formData);
    SuccessToast(response.data?.Details || "Success");
    return response.data;
  } catch (error: any) {
    ErrorToast(error?.response?.data?.Details || "Something went wrong");
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});

export const AttractionsImageUpload = createAsyncThunk("Attraction/AttractionImageUpdate", async (formData: any) => {
  try {
    const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Attraction/AttractionImageUpdate`, formData, {
      headers: { "content-type": "multipart/form-data" },
    });
    SuccessToast(response.data?.Details || "Success");
    return response.data;
  } catch (error: any) {
    ErrorToast(error?.response?.data?.Details || "Something went wrong");
    return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
  }
});
